export default __webpack_public_path__ + "static/media/phone.9ffcf787.svg";